<sb-card class="flex flex-1 flex-col self-start border-0 p-5 shadow">
  <sb-checklist-progress-heading [title]="title()" [titleSize]="'xl'" [progress]="progress()" />

  <sb-checklist-content [items]="items()" class="mt-5">
    @if (showFooter()) {
      <book-a-call-footer sb-checklist-footer [originator]="'dashboard'" />
    }
  </sb-checklist-content>

  <button sb-button class="self-end font-bold" [color]="'transparent'" [size]="'sm'" (click)="handleClick()">
    {{ 'Dismiss checklist' | translate }}
  </button>
</sb-card>
